import { isomorphicVars } from "./scripts/isomorphicVars"
import { browserHistory } from "react-router"
import { getAccountSettings } from "./scripts/accountSettings"
import TagManager from "react-gtm-module"

const getGoogleAnalyticsType = gaId => {
  if (gaId && (gaId.startsWith("G-") || gaId.startsWith("UA-"))) {
    return "gtag"
  } else if (gaId && gaId.startsWith("GTM-")) {
    return "gtm"
  }

  return null
}

const initGoogleAnalytics = gaId => {
  switch (getGoogleAnalyticsType(gaId)) {
    case "gtag":
      if (typeof gtag === "undefined") {
        return
      }

      gtag("js", new Date())
      gtag("config", gaId, { send_page_view: false })
      break

    case "gtm":
      const tagManagerArgs = {
        gtmId: gaId
      }

      TagManager.initialize(tagManagerArgs)
      break
  }
}

const sendPageView = gaId => {
  switch (getGoogleAnalyticsType(gaId)) {
    case "gtag":
      if (typeof gtag === "undefined") {
        return
      }

      const eventData = {
        page_location: window.location.origin + window.location.pathname,
        page_title: document.title,
        send_to: gaId
      }

      gtag("event", "page_view", eventData)
      break

    case "gtm":
      const tagManagerArgs = {
        dataLayer: {
          event: "pageview",
          page: {
            page_location: window.location.origin + window.location.pathname,
            page_title: document.title
          }
        }
      }

      TagManager.dataLayer(tagManagerArgs)
      break
  }
}

export function analyticsListen(authenticAccountId) {
  const { fb_id: fbId } = isomorphicVars()

  if (!typeof window === "undefined") {
    return
  }

  const { google_analytics_code: gaId } = getAccountSettings(authenticAccountId)

  initGoogleAnalytics(gaId)

  window.fbAsyncInit = () => {
    global.FB.init({
      appId: fbId || "1268560306508453",
      xfbml: true,
      version: "v2.10"
    })

    global.FB.AppEvents.logPageView()

    browserHistory.listen(event => {
      global.FB.AppEvents.logPageView()

      sendPageView(gaId)
    })
  }
}

export function trackEvent(category, action, label = undefined) {
  if (typeof window !== "undefined") {
    if (typeof gtag !== "undefined") {
      gtag("event", action, {
        event_category: category,
        event_label: label
      })

      return true
    } else if (window.dataLayer && window.dataLayer[0].event === "gtm.js") {
      TagManager.dataLayer({
        dataLayer: {
          event: "customEvent",
          eventCategory: category,
          eventAction: action,
          eventLabel: label
        }
      })

      return true
    }

    return false
  }
  return false
}

export function trackDownload(eventLabel) {
  if (typeof window !== "undefined") {
    if (typeof gtag !== "undefined") {
      gtag("event", "download", {
        event_category: "resource",
        event_label: eventLabel
      })

      return true
    } else if (window.dataLayer && window.dataLayer[0].event === "gtm.js") {
      TagManager.dataLayer({
        dataLayer: {
          event: "trackDownload",
          eventCategory: "resource",
          eventAction: "download",
          eventLabel
        }
      })

      return true
    }
  }

  return false
}

export function trackSocial(socialNetwork, socialTarget) {
  if (typeof window !== "undefined") {
    if (typeof gtag !== "undefined") {
      gtag("event", "share", {
        method: socialNetwork,
        event_action: "Share",
        event_label: socialTarget
      })

      return true
    } else if (window.dataLayer && window.dataLayer[0].event === "gtm.js") {
      TagManager.dataLayer({
        dataLayer: {
          event: "socialInteraction",
          socialNetwork,
          socialAction: "Share",
          socialTarget
        }
      })

      return true
    }
  }
}



// WEBPACK FOOTER //
// ./webapp/analyticsAndSocial.js